import React, { useEffect, useRef } from 'react';
import './OwlDemo.scss';
import Slider from 'react-slick';
import DemoVideo from './DemoVideo/DemoVideo';
import { videoDataLayer } from '../../util/videoDataLayer';

/**
 * Renders the owl demo module
 * @param {string} title
 * @param {string} description
 * @param {array} demos
 * @returns {JSX.Element}
 * @constructor
 */
const OwlDemo = ({ title, description, demos }) => {
  const tabs = demos.map((demo) => demo.demoName);
  const videos = demos.map((demo) => {
    return {
      videoUrl: demo.demoVideoUrl,
      posterUrl: demo.demoVideoPoster,
    };
  });

  const videosSlider = useRef();
  const tabsSlider = useRef();
  const videosRefs = useRef([]);

  useEffect(() => {
    const { dataLayer } = window;

    Object.keys(videos).forEach((video, i) => {
      videosRefs.current[i].addEventListener('play', () => {
        videoDataLayer(videosRefs.current[i], dataLayer);
      });
    });
  }, []);

  const handlePlay = (index) => {
    if (videosRefs.current[index].paused) {
      videosRefs.current[index].play();
    } else {
      videosRefs.current[index].pause();
    }
  };

  const pauseAllVideos = () => videosRefs.current.forEach((video) => video.pause());

  const tabSettings = {
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: tabs.length,
    slidesToScroll: 1,
    afterChange: pauseAllVideos,
    asNavFor: videosSlider.current,
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  };

  const videoSettings = {
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: tabsSlider.current,
  };

  const renderTabs = (tabs) =>
    tabs.map((tab) => <button className="c-owl-demo__tab eyebrow-2">{tab}</button>);

  const renderVideos = (videos) =>
    videos.map((video, i) => (
      <div className="c-owl-demo__video">
        <DemoVideo
          ref={(el) => (videosRefs.current[i] = el)}
          source={video.videoUrl}
          poster={video.posterUrl}
          handlePlay={handlePlay}
          index={i}
        />
      </div>
    ));

  return (
    <div className="c-owl-demo background-color-gray">
      <div className="c-owl-demo__inner">
        <div className="c-owl-demo__header">
          <div className="c-owl-demo__title h1-roobert">
            <h1>{title}</h1>
          </div>
          <div className="c-owl-demo__description body-1">
            <p>{description}</p>
          </div>
        </div>
        <div className="c-owl-demo__tabs-container-fluid">
          <div className="c-owl-demo__tabs-container">
            <Slider ref={tabsSlider} className="c-owl-demo__tabs" {...tabSettings}>
              {renderTabs(tabs)}
            </Slider>
          </div>
        </div>
        <div className="c-owl-demo__videos-container">
          <Slider ref={videosSlider} className="c-owl-demo__videos" {...videoSettings}>
            {renderVideos(videos)}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default OwlDemo;
